module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer"
  }, [_c('a', {
    attrs: {
      "href": "https://dowhile.com.br/"
    }
  }, [_vm._v("Dowhile")]), _vm._v(" © 2019.\n  "), _c('span', {
    staticClass: "float-right"
  }, [_vm._v("Desenvolvido por "), _c('a', {
    attrs: {
      "href": "https://dowhile.com.br/",
      "target": "_blank"
    }
  }, [_vm._v("Dowhile")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-410cd778","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 853
// module chunks = 1